module.exports = __webpack_public_path__ + "img/Frame 2135.623d3c41.png";